var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row my-3 mx-0"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"btn btn-primary float-right mx-1",attrs:{"type":"button"},on:{"click":function($event){return _vm.createRemoteJob()}}},[_vm._v(_vm._s(this.button_text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }